import * as actionTypes from "redux/constants/dashboard";

const initialState = {
  bod2_summary: null,
  bod2_gap: null,
  bod3_summary: null,
  bod3_gap: null,
};

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_BOD2_SUMMARY:
      return {
        ...state,
        bod2_summary: action.payload,
      };
    case actionTypes.GET_BOD2_GAP:
      return {
        ...state,
        bod2_gap: action.payload,
      };
    case actionTypes.GET_BOD3_SUMMARY:
      return {
        ...state,
        bod3_summary: action.payload,
      };
    case actionTypes.GET_BOD3_GAP:
      return {
        ...state,
        bod3_gap: action.payload,
      };
    default:
      return state;
  }
}
